import HakAksesApproval from './HakAksesApprovalNew'

export default HakAksesApproval